import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import SendIcon from "@material-ui/icons/Send";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import StarBorder from "@material-ui/icons/StarBorder";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const activeStyle = {
  color: "rgb(71 112 218)",
  backgroundColor: "rgb(83 131 255 / 16%)",
};

const activeIconStyle = {
  color: "rgb(71 112 218)",
};

export default function MenuItem(props) {
  const classes = useStyles();
  const [collapseOpen, setCollapseOpen] = React.useState(false);

  const {
    name,
    icon,
    subOptions,
    navigate,
    path,
    page,
    open,
    handleDrawerOpen,
  } = props;

  const onMenuItemClick = (path) => {
    if (!open) handleDrawerOpen();
    navigate(path);
  };

  const handleClick = () => {
    if (!open) handleDrawerOpen();
    setCollapseOpen(!collapseOpen);
  };

  if (subOptions && Array.from(subOptions)) {
    return (
      <>
        <ListItem button onClick={handleClick}>
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText
            primary={<EventLabel2 name={name} groupName="Exhibitor.Admin" />}
          />
          {(!open ? false : collapseOpen) ? (
            <ExpandLess style={{ color: "rgba(0, 0, 0, 0.54)" }} />
          ) : (
            <ExpandMore style={{ color: "rgba(0, 0, 0, 0.54)" }} />
          )}
        </ListItem>
        <Collapse
          in={!open ? false : collapseOpen}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {subOptions.map((c, i) => {
              return (
                <ListItem
                  key={i}
                  button
                  style={c.path == page ? activeStyle : undefined}
                  onClick={() => onMenuItemClick(c.path)}
                  className={classes.nested}
                >
                  <ListItemIcon
                    style={c.path == page ? activeIconStyle : undefined}
                  >
                    {c.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <EventLabel2 name={c.name} groupName="Exhibitor.Admin" />
                    }
                  />
                </ListItem>
              );
            })}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <ListItem
      button
      style={path == page ? activeStyle : undefined}
      onClick={() => onMenuItemClick(path)}
    >
      <ListItemIcon style={path == page ? activeIconStyle : undefined}>
        {icon}
      </ListItemIcon>
      <ListItemText
        primary={<EventLabel2 name={name} groupName="Exhibitor.Admin" />}
      />
    </ListItem>
  );
}
